import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { I18n, NgtButtonComponent, TranslatePipe } from '@corporate/ng-tebis-base-components';
import { videos } from './help-videos';
import { DomSanitizer } from '@angular/platform-browser';
import { UserPreferencesService } from '../user-preferences/user-preferences.service';

@Component({
  selector: 'tebitasks-help-page',
  imports: [
    MatIconModule,
    NgtButtonComponent,
    TranslatePipe,
  ],
  templateUrl: './help-page.component.html',
  styleUrl: './help-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpPageComponent {

  i18n = inject(I18n);
  dialogRef = inject(MatDialogRef);
  domSanitizer = inject(DomSanitizer);

  userPrefs = inject(UserPreferencesService);
  helpPageAutostart = computed(() => this.userPrefs.userPreferences().helpPageAutostart || false);

  videos = videos;

  constructor() {
    inject(I18n).addNamespace('help');
  }

  close() {
    this.dialogRef.close();
  }

  trustUrl(url: string) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  hideAndRemember() {
    this.dialogRef.close();
    this.userPrefs.patch({ helpPageAutostart: false });
  }
}
